import { Moment } from 'moment';
import { TrendDataScale } from './TrendDataScale';

export class TrendData {
  constructor(
    private readonly from: Moment,
    private readonly to: Moment,
    private readonly highInstances: number,
    private readonly mediumInstances: number,
    private readonly lowInstances: number,
    private readonly passedInstances: number
  ) {}

  getFrom() {
    return this.from;
  }

  getTo() {
    return this.to;
  }

  getHighInstances() {
    return this.highInstances;
  }

  getMediumInstances() {
    return this.mediumInstances;
  }

  getLowInstances() {
    return this.lowInstances;
  }

  getPassedInstances() {
    return this.passedInstances;
  }

  getFormattedDate(scale = TrendDataScale.DAY) {
    switch (scale) {
      case TrendDataScale.MONTH:
        return this.to.format('MMM YYYY');
      case TrendDataScale.HOUR:
        return [this.from.format('ha'), this.to.format('ha')].join(' - ');
      case TrendDataScale.MINUTE:
        return [this.from.format('hh:mma'), this.to.format('hh:mma')].join(' - ');
      case TrendDataScale.SECONDS:
        return [this.from.format('hh:mm:ssa'), this.to.format('hh:mm:ssa')].join(' - ');
      case TrendDataScale.DAY:
      default:
        return this.to.format('MMM Do');
    }
  }
}
